function setupProductCardSwatches() {
  document.querySelectorAll('.product-card-item').forEach(productCard => {
    const isMobile = window.matchMedia('(max-width:1024px)').matches;
    const limit = isMobile ? 3 : 8;

    const mainImage = productCard.querySelector('.card__media img');
    if (!mainImage) return;


    const rawSwatches = productCard.querySelectorAll('.product-card_swatch');
    const swatchItems = [];
    const seenElements = new Set();
    rawSwatches.forEach(node => {
      const dataEl = node.hasAttribute('data-variant-image') ? node : node.querySelector('[data-variant-image]');
      if (dataEl && !seenElements.has(dataEl)) {
        seenElements.add(dataEl);
        swatchItems.push(dataEl);
      }
    });

    const allSwatchWrappers = [];

    swatchItems.forEach((dataEl, index) => {
      const wrapper = dataEl.parentElement && dataEl.parentElement.classList && dataEl.parentElement.classList.contains('product-card_swatch')
        ? dataEl.parentElement
        : dataEl;

      allSwatchWrappers.push(wrapper);

      wrapper.style.display = 'block';
      dataEl.style.display = 'block';
      if (index >= limit) {
        wrapper.style.display = 'none';
        dataEl.style.display = 'none';
      }

      wrapper.setAttribute('role', 'button');
      wrapper.setAttribute('tabindex', '0');

      const baseUrl = dataEl.getAttribute('data-variant-base');
      const width = dataEl.getAttribute('data-variant-width');
      
      const variant460Src = baseUrl ? generate460Image(baseUrl) : null;

      if (!isMobile && variant460Src) {
        wrapper.addEventListener('mouseenter', () => {
          preloadImage(variant460Src);
        }, { once: true, passive: true });
      }

      const handleInteraction = e => {
        const canSwap = Boolean(variant460Src && baseUrl && width);
        if (canSwap) {
          e.preventDefault();
          mainImage.src = variant460Src;
          mainImage.srcset = generateSrcset(baseUrl, width);
          allSwatchWrappers.forEach(s => s.classList.remove('active'));
          wrapper.classList.add('active');
          dataEl.classList.add('active');
          wrapper.blur();
        }
      };

      wrapper.addEventListener('pointerdown', handleInteraction);
      wrapper.addEventListener('keydown', e => {
        if (e.key === 'Enter') handleInteraction(e);
      });
    });
  });
}

function generate460Image(baseUrl) {
  if (!baseUrl) return null;
  
  const urlParts = baseUrl.split('?');
  const cleanUrl = urlParts[0];
  const queryParams = urlParts[1] || '';
  
  const ext = cleanUrl.split('.').pop();
  const cleanBase = cleanUrl.replace(/\.\w+$/, '');
  
  const versionMatch = queryParams.match(/v=\d+/);
  const versionParam = versionMatch ? versionMatch[0] : '';
  
  if (versionParam) {
    return `${cleanBase}_460x460.${ext}?${versionParam}&width=460`;
  } else {
    return `${cleanBase}_460x460.${ext}?width=460`;
  }
}

function generateSrcset(baseUrl, maxWidth) {
  if (!baseUrl || !maxWidth) return '';

  const urlParts = baseUrl.split('?');
  const cleanUrl = urlParts[0];
  const queryParams = urlParts[1] || '';
  
  // Extract version parameter
  const versionMatch = queryParams.match(/v=\d+/);
  const versionParam = versionMatch ? versionMatch[0] : '';

  // Cap at 460px maximum
  const sizes = [460];
  const ext = cleanUrl.split('.').pop();
  const cleanBase = cleanUrl.replace(/\.\w+$/, '');

  const srcset = sizes
    .filter(size => size <= Math.min(parseInt(maxWidth), 460))
    .map(size => {
      const url = versionParam 
        ? `${cleanBase}_${size}x${size}.${ext}?${versionParam}&width=${size}`
        : `${cleanBase}_${size}x${size}.${ext}?width=${size}`;
      return `${url} ${size}w`;
    });

  return srcset.join(', ');
}

function preloadImage(url) {
  const img = new Image();
  img.src = url;
}

document.addEventListener('DOMContentLoaded', setupProductCardSwatches);
